import {
  Box,
  BoxProps,
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { features } from '../../../../../config/features';
import { useAuth } from '../../../../../hooks/auth';
import { AppointmentPaymentsReportList } from './components/AppointmentPaymentsReportList';
import { BookingExternalPaymentsReportList } from './components/BookingExternalPaymentsReportList';

export const BookingPaymentsReportTabs = (props: BoxProps): JSX.Element => {
  const { assignment: authenticatedAssignment } = useAuth();

  const [tabIndex, setTabIndex] = useState(0);
  const showAppointmentReports =
    features.productsServicesEnabled &&
    authenticatedAssignment?.featureGroup.features.some((feature) =>
      [
        'APPOINTMENT_PAYMENT_REPORTS_FULL_ACCESS',
        'APPOINTMENT_PAYMENT_REPORTS_READ_ACCESS',
      ].includes(feature.key),
    );

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Flex justify="space-between" align="center">
        <Heading size="lg" fontWeight="normal">
          Relatórios de vendas
        </Heading>
      </Flex>

      <Tabs
        mt="8"
        index={tabIndex}
        isLazy
        onChange={handleTabChanges}
        variant="enclosed-colored"
      >
        <TabList>
          {/* <Tab>Pagamentos app</Tab> */}

          <Tab>Pagamentos club</Tab>

          {showAppointmentReports && <Tab>Ordens de serviço</Tab>}
        </TabList>

        <TabPanels>
          {/* <TabPanel>
            <BookingPaymentsReportList />
          </TabPanel> */}

          <TabPanel>
            <BookingExternalPaymentsReportList />
          </TabPanel>

          {showAppointmentReports && (
            <TabPanel>
              <AppointmentPaymentsReportList />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
